import { useEffect, useState } from 'react';

import { ElementSize, getPositionFromRelative, Position, RelativePosition } from '../utils';

interface UseResponsivePositionProps {
  relativePosition: RelativePosition;
  elementSize: ElementSize;
}

export const useResponsivePosition = ({
  relativePosition,
  elementSize,
}: UseResponsivePositionProps) => {
  const [position, setPosition] = useState<Position>(() =>
    getPositionFromRelative(relativePosition, elementSize)
  );

  useEffect(() => {
    const handleResize = () => {
      setPosition(getPositionFromRelative(relativePosition, elementSize));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [relativePosition, elementSize]);

  useEffect(() => {
    setPosition(getPositionFromRelative(relativePosition, elementSize));
  }, [relativePosition, elementSize]);

  return { position, setPosition };
};
